import { CoachCompany } from '../../../lib/types/models/ol/coach-company/coach-company'
import { CoachCompanyInput } from '../../../lib/types/models/ol/coach-company/coach-company-input'
import { API, constructApiUrl } from '../../apis.config'
import { restApiClient } from '../../rest-api-client'

export const createCoachCompany = async (input: CoachCompanyInput & { olId: number }) => {
  const { olId, ...data } = input

  return restApiClient
    .url(constructApiUrl(API.ols.createCoachCompany.url, { olId }))
    .post<CoachCompany, CoachCompanyInput>(data)
}
